<p-breadcrumb [model]="routePath"></p-breadcrumb>
<div appAccessProvider [accessCode]="{ menuCode: 'PROTOCOLS', pageCode: 'ALL', subPageCode: 'VIEW' }">
    <div class="grid mt-1 details-div border-200 mr-0 pl-2 pr-3 pb-2">
        <div class="col-7 md:col-7  details-header-spacing">
            @if (showStatus) {
            <app-status [dataForVehicleStatus]="dataForProtocolStatus" [userId]="userId"
                [entityForStatus]="entityForStatus" [imgFileUrl]="" [imgFileId]="" [showImage]="false"></app-status>
            }
        </div>
        @if(!configService.isSiteUser() && !configService.isSponsor()){
        <div appAccessProvider [accessCode]="{ menuCode: 'PROTOCOLS', pageCode: 'ALL', subPageCode: 'EDIT' }"
            class="col-5 text-right flex align-items-center justify-content-end details-header-space pr-2">
            @if (isAllowToEdit()) {
            <button (click)="edit()" pButton
                class="edit-btn border-400 bg-white text-color mr-1 btn-custom mr-2 hover:surface-100"
                [label]="editBtnLabel">
                <i class="mi-lg mr-2 edit-pen edit_pencil"></i>
            </button>
            }
            @if (isAllowToGenerateReport()) {
            <button (click)="generateOrderReport()" pButton class="edit-btn secondary-btn mr-1 btn-custom mr-2 "
                label="Generate Order Report">
                <i class="mi-lg mr-2  {{miIcons.GENERATE_REPORT}} "></i>
            </button>
            }
            @if (isAllowToDeactivate()) {
            <button (click)="onDeactivate()" pButton class="edit-btn error-btn text-white mr-1 btn-custom mr-2 "
                [label]="'protocol.lbl_deactivate' | translate">
                <i class="mi-lg mr-2 {{miIcons.ACTIVATE}} bg-white"></i>
            </button>
            }
            @if (isProtocolStatusDraft()) {
            <p-button class="flex align-items-center justify-content-center button-hide"
                icon="mi-lg mr-2 {{miIcons.CIRCLE_CHECKED}} bg-white" [label]="'protocol.lbl_activate' | translate"
                (click)="onActivate()"></p-button>
            }
            <!-- } -->
        </div>
        }
    </div>
    <div class="flex pl-3 pr-3 pb-2">

        <div class="flex-1 mr-2">
            <p-card class="header-card cursor-pointer" (click)="navigateToTab(getTabIndexByName('orders'))">
                <div class="label" translate>lbl_total_orders</div>
                @if (entityCount) {
                <div class="mt-1 text-2xl font-bold">{{entityCount.order_count}}</div>
                } @else {
                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                }
            </p-card>
        </div>

        <div class="flex-1 mr-2 ml-2">
            <p-card class="header-card cursor-pointer" (click)="navigateToTab(getTabIndexByName('products'))">
                <div class="label" translate>lbl_total_products</div>
                @if (entityCount) {
                <div class="mt-1 text-2xl font-bold">{{entityCount.product_count}}</div>
                } @else {
                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                }
            </p-card>
        </div>

        @if(!configService.isSiteUser()){
        <div class="flex-1 mr-2 ml-2">
            <p-card class="header-card cursor-pointer" (click)="navigateToTab(getTabIndexByName('sites'))">
                <div class="label" translate>lbl_total_sites</div>
                @if (entityCount) {
                <div class="mt-1 text-2xl font-bold">{{entityCount.site_count}}</div>
                } @else {
                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                }
            </p-card>
        </div>
        }


        <div class="flex-1 mr-2 ml-2" appAccessProvider
            [accessCode]="{ menuCode: 'PROTOCOL_PATIENTS', pageCode: 'LIST', subPageCode: '' }">
            @if(isPatientManagmentOn && configService.isSiteUser()) {
            <p-card class="header-card cursor-pointer" (click)="navigateToTab(getTabIndexByName('patients'))">
                <div class="label" translate>lbl_active_patient</div>
                @if (entityCount) {
                <div class="mt-1 text-2xl font-bold">{{entityCount.active_patient_count}}</div>
                } @else {
                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                }
            </p-card>
            }
        </div>

        @if(!configService.isSiteUser()){
        <div class="flex-1 mr-2 ml-2">
            <p-card class="header-card cursor-pointer" (click)="navigateToTab(getTabIndexByName('purchase-orders'))">
                <div class="label" translate>lbl_budget_utilized</div>
                @if (entityCount) {
                <div class="mt-1 text-2xl font-bold">
                    {{(attributeValues?.used_budget || 0) |
                    currency:'USD':'symbol':'1.2-2'}}/{{(attributeValues?.total_budget || 0) |
                    currency:'USD':'symbol':'1.2-2'}}
                </div>
                } @else {
                <p-skeleton height="2rem" class="mt-1"></p-skeleton>
                }
            </p-card>
        </div>
        }
    </div>
    <p-tabView [ngClass]="{'custom-tabview': isReviewer, 'custom-tabview-admin': !isReviewer}"
        [(activeIndex)]="activeIndex" [scrollable]="true" (activeIndexChange)="activeIndexChange($event)"
        [scrollable]="true" class="vehicle-detail-tab">
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg overview"></i>
                <label class="capitalize" translate>protocol.lbl_overview</label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('overview') && activeIndex === getTabIndexByName('overview')) {
            <app-overview-details
                [isAllowToEdit]="isAllowToEdit()"
                [attributeValues]="attributeValues"
                [attributeLabels]="attributeLabels"
                [trialAttributeData]="trialAttributeData"
                [protocolEntityId]="trialId"
                [protocolRowData]="currentRow"
                [trialDetails]="trialDetails"
                [isDeleted]="isDeleted"
                [isUnassigned]="isUnassigned"></app-overview-details>
            }
        </p-tabPanel>

        @if(isProductsTab) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg protocol-products"></i>
                <label class="capitalize"><span translate>protocol.lbl_products
                    </span>({{entityCount?.product_count}})</label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('products') && activeIndex === getTabIndexByName('products')) {
            <app-products
                [isAllowToAddProduct]="isAllowToAddProduct()"
                [isChangeReasonNotRequired]="isChangeReasonNotRequired()"
                [isEditNotAllowed]="isEditNotAllowed()"
                [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus()"
                (saveSuccess)="onEntityAdded()" />
            }
        </p-tabPanel>
        }

        @if(isPurchaseOrdersTab) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-purchase_order"></i>
                <label class="capitalize"><span translate>protocol.lbl_purchase_orders
                    </span>({{entityCount?.purchase_order_count}})</label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('purchase-orders') && activeIndex ===
            getTabIndexByName('purchase-orders')) {
            <app-purchase-orders
                [isAllowToAddProduct]="isAllowToAddProduct()"
                [isChangeReasonNotRequired]="isChangeReasonNotRequired()"
                [isEditNotAllowed]="isEditNotAllowed()"
                [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus()"
                (saveSuccess)="onEntityAdded()" />
            }
        </p-tabPanel>
        }

        @if(isOrdersTab) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-orders"></i>
                <label class="capitalize"> <span translate>protocol.lbl_orders
                    </span>({{entityCount?.order_count}})</label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('orders') && activeIndex === getTabIndexByName('orders')) {
            <app-orders
                [isChangeReasonNotRequired]="isChangeReasonNotRequired()"
                [isEditNotAllowed]="isEditNotAllowed()"
                [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus()" />
            }
        </p-tabPanel>
        }

        @if(isSitesTab) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-sites"></i>
                <label class="capitalize"> <span translate>protocol.lbl_sites
                    </span> @if(!isSiteUser){ ({{entityCount?.site_count}}) } </label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('sites') && activeIndex === getTabIndexByName('sites')) {
            <app-sites
                [isAllowToAddProduct]="isAllowToAddProduct()"
                [isChangeReasonNotRequired]="isChangeReasonNotRequired()"
                [isEditNotAllowed]="isEditNotAllowed()"
                [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus()"
                (saveSuccess)="onEntityAdded()" />
            }
        </p-tabPanel>
        }

        @if(isSponsorsTab) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-sponsors"></i>
                <label class="capitalize"> <span translate>protocol.lbl_sponsor</span></label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('sponsors') && activeIndex === getTabIndexByName('sponsors')) {
            <app-sponsors
                [attributeValues]="attributeValues"
                [attributeLabels]="sponsorAttributeLabels"
                [trialAttributeData]="trialAttributeData"
                [vehicleEntityId]="trialId"
                [vehicleRowData]="currentRow"
                [trialDetails]="trialDetails"
                [isDeleted]="isDeleted"
                [isUnassigned]="isUnassigned"></app-sponsors>
            }
        </p-tabPanel>
        }

        @if(isUsersTab) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-protocol_users"></i>
                <label class="capitalize"> <span translate>protocol.lbl_protocol_users
                    </span>({{entityCount?.protocol_user_count}})</label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('protocol-users') && activeIndex ===
            getTabIndexByName('protocol-users')) {
            <app-protocol-users
                [isActive]="activeIndex === getTabIndexByName('protocol-users')"
                [isEditNotAllowed]="isEditNotAllowed()"
                [isEditNotAllowedSpecificStatus]="isEditNotAllowedSpecificStatus()"
                [isChangeReasonNotRequired]="isChangeReasonNotRequired()"
                [isAllowToAddProduct]="isAllowToAddProduct()" [attributeValues]="attributeValues"
                [protocolId]="trialId"
                (saveSuccess)="onEntityAdded()" />
            }
        </p-tabPanel>
        }

        @if(isActivityFeedTab) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg mi-protocol_activity_feed"></i>
                <label class="capitalize"> <span translate>protocol.lbl_activity_feed</span></label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('activity-feed') && activeIndex ===
            getTabIndexByName('activity-feed')) {
            <app-activity-feed [isActive]="activeIndex === getTabIndexByName('activity-feed')" />
            }
        </p-tabPanel>
        }

        @if(isPatientsTab && isPatientManagmentOn) {
        <p-tabPanel>
            <ng-template pTemplate="header">
                <i class="mi-lg {{miIcons.PATIENT_PLUS}}"></i>
                <label class="capitalize"> <span translate>protocol.lbl_patients
                    </span>({{entityCount?.patient_count}})
                </label>
            </ng-template>
            @if (trialDetails && isTabLoadedByName('patients') && activeIndex === getTabIndexByName('patients')) {
            <app-patients [isAllowToAddProduct]="isAllowToAddProduct()" (saveSuccess)="onEntityAdded()"
                [protocolDates]="protocolDates" />
            }
        </p-tabPanel>
        }
    </p-tabView>
</div>